import {
    CadastrarSubCategoriaService,
    AtualizarSubCategoriaService,
    DeletarSubCategoriaService,
    ListarSubCategoriaService,
    ListarVariasSubCategoriasService,
} from "../../../../Services/Geral/GestaoDeCadastros/SubCategoria/SubCategoriaServices";

import { ISubCategoria } from "../../../../Interfaces/Geral/GestaoDeCadastro/SubCategoria/SubCategoriaInterfaces";
import { ISubCategoria as ISubCategorias } from "../../../../Interfaces/Geral/SubCategoria/SubCategoriaInterface";

import { Controller } from "../../../Controller";

export async function CadastrarSubCategoriaController(
    requestBody: ISubCategorias
) {
    return Controller(CadastrarSubCategoriaService(requestBody));
}

export async function AlterarSubCategoriaController(
    requestBody: ISubCategoria
) {
    return Controller(AtualizarSubCategoriaService(requestBody));
}

export async function DeletarSubCategoriaController(IDSubCategoria: number) {
    return Controller(DeletarSubCategoriaService(IDSubCategoria));
}

export async function ListarSubCategoriaController(
    IDCategoria: number | number[],
    IDProduto?: number
    // categoriaAtendimento?: string
) {
    return Controller(
        ListarSubCategoriaService(
            IDCategoria,
            IDProduto
            // categoriaAtendimento
        )
    );
}

export async function ListarVariasSubCategoriasController(
    ID_PRODUTO: string | number | number[],
    ID_CATEGORIA_ATENDIMENTO: number | number[]
) {
    return Controller(
        ListarVariasSubCategoriasService(ID_PRODUTO, ID_CATEGORIA_ATENDIMENTO)
    );
}
